import type { MapDispatchToProps } from 'react-redux';
import { connect } from 'react-redux';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import * as addonSelector from 'state/addonForm/addonForm.selector';
import { addonQuoteRequestedThunk } from 'state/addonForm/addonForm.thunks';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

interface OwnProps {
  tabId: string;
}
interface StateProps {
  isDisabled: boolean;
  isNotReadyToQuote: boolean;
}

interface DispatchProps {
  onAddOnQuoteRequested: () => void;
}

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  const validationErrors = addonSelector.getValidationErrors(state, tabId) ?? [];
  const status = addonSelector.getLoadingStatus(state, tabId);
  const hasErrors = validationErrors.some(error => error.severity === 'Error');

  const isResetting = status === 'Resetting';

  return {
    isNotReadyToQuote: hasErrors,
    isDisabled: hasErrors || isResetting,
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch: ThunkDispatch,
  { tabId },
): DispatchProps => ({
  onAddOnQuoteRequested: () => {
    logAnalytics.trackEvent('Addon', 'Request for tradable quote');
    dispatch(addonQuoteRequestedThunk(tabId));
  },
});
export type AddonQuoteActionsProps = OwnProps & StateProps & DispatchProps;

export const connectAddonQuoteAction = connect(mapStateToProps, mapDispatchToProps);
